// extracted by mini-css-extract-plugin
export default {"kitchen-view":"kitchen_kitchen-view__kuUEL","kitchen-container":"kitchen_kitchen-container__+VytC","no-orders":"kitchen_no-orders__aXdoT"};